import { pxToRem, theme } from '@pocketlaw/tetris';
import { css } from 'styled-components';
export const themeStyles = css `
  --ck-icon-size: ${pxToRem(16)};

  /* -- Overrides the border radius setting in the theme. ------------------------------------- */

  --ck-border-radius: ${pxToRem(0)};

  /* -- Overrides the default font size in the theme. ----------------------------------------- */

  --ck-font-size-base: ${theme.fontSize.small};

  /* -- Helper variables to avoid duplication in the colors. ---------------------------------- */

  --ck-custom-background: ${theme.semantic.surface.primary};
  --ck-custom-foreground: ${theme.semantic.surface.primary};
  --ck-custom-border: ${theme.semantic.border.default};
  --ck-custom-white: ${theme.semantic.surface.primary};

  /* -- Overrides generic colors. ------------------------------------------------------------- */

  --ck-color-base-foreground: var(--ck-custom-background);
  --ck-color-focus-border: ${theme.semantic.border.strong};
  --ck-color-text: ${theme.semantic.foreground.secondary};

  /* -- Overrides shadows ---------------------------------------------------------------------- */

  --ck-drop-shadow: ${theme.dropShadow[400]};
  --ck-drop-shadow-active: ${theme.dropShadow[400]};

  /* -- Overrides spacing ---------------------------------------------------------------------- */

  --ck-spacing-unit: 0.6em;
  --ck-spacing-large: calc(var(--ck-spacing-unit) * 1.5);
  --ck-spacing-standard: var(--ck-spacing-unit);
  --ck-spacing-medium: calc(var(--ck-spacing-unit) * 0.8);
  --ck-spacing-small: ${theme.spacing.sm};
  --ck-spacing-tiny: ${theme.spacing.sm};
  --ck-spacing-extra-tiny: ${theme.spacing.xs};

  /* -- Overrides the default .ck-button class colors. ---------------------------------------- */

  --ck-color-button-on-color: ${theme.swatches.warm[500]};
  --ck-color-button-default-background: var(--ck-custom-background);
  --ck-color-button-default-hover-background: ${theme.semantic.action.secondary.hover};
  --ck-color-button-default-active-background: ${theme.semantic.action.secondary.active};
  --ck-color-button-default-active-shadow: none;
  --ck-color-button-default-disabled-background: var(--ck-custom-background);
  --ck-color-button-on-background: var(--ck-custom-background);
  --ck-color-button-on-hover-background: ${theme.semantic.action.secondary.hover};
  --ck-color-button-on-active-background: ${theme.semantic.action.secondary.active};
  --ck-color-button-on-active-shadow: none;
  --ck-color-button-on-disabled-background: var(--ck-custom-foreground);
  --ck-color-button-action-background: var(--ck-custom-background);
  --ck-color-button-action-hover-background: ${theme.semantic.action.secondary.hover};
  --ck-color-button-action-active-background: ${theme.semantic.action.secondary.active};
  --ck-color-button-action-active-shadow: none;
  --ck-color-button-action-disabled-background: var(--ck-custom-foreground);
  --ck-color-button-action-text: var(--ck-color-text);
  --ck-color-button-cancel: ${theme.semantic.text.danger};

  /* -- Overrides the default .ck-dropdown class colors. -------------------------------------- */

  --ck-color-dropdown-panel-background: var(--ck-custom-background);
  --ck-color-dropdown-panel-border: ${theme.semantic.border.default};

  /* -- Overrides the default .ck-split-button class colors. ----------------------------------- */

  --ck-color-split-button-hover-background: var(--ck-color-button-default-hover-background);
  --ck-color-split-button-hover-border: var(--ck-custom-foreground);

  /* -- Overrides the default .ck-input class colors. ----------------------------------------- */

  --ck-color-input-background: var(--ck-custom-background);
  --ck-color-input-border: hsl(257deg 3% 43%);
  --ck-color-input-text: hsl(0deg 0% 98%);
  --ck-color-input-disabled-background: hsl(255deg 4% 21%);
  --ck-color-input-disabled-border: hsl(250deg 3% 38%);
  --ck-color-input-disabled-text: hsl(0deg 0% 78%);

  /* -- Overrides the default .ck-labeled-field-view class colors. ---------------------------- */

  --ck-color-labeled-field-label-background: var(--ck-custom-background);

  /* -- Overrides the default .ck-list class colors. ------------------------------------------ */

  --ck-color-list-background: var(--ck-custom-background);
  --ck-color-list-button-hover-background: ${theme.semantic.action.secondary.hover};
  --ck-color-list-button-on-background: ${theme.swatches.blue[400]};
  --ck-color-list-button-on-background-focus: ${theme.swatches.blue[400]};
  --ck-color-list-button-on-text: var(--ck-color-base-background);

  /* -- Overrides the default .ck-balloon-panel class colors. --------------------------------- */

  --ck-color-panel-background: var(--ck-custom-background);
  --ck-color-panel-border: var(--ck-custom-border);

  /* -- Overrides the default .ck-toolbar class colors. --------------------------------------- */

  --ck-color-toolbar-background: var(--ck-custom-background);
  --ck-color-toolbar-border: ${theme.semantic.border.default};

  /* -- Overrides the default .ck-comment class colors. --------------------------------------- */

  --ck-color-comment-separator: ${theme.swatches.warm[50]};
  --ck-color-comment-background: ${theme.semantic.surface.primary};

  /* -- Overrides the default .ck-annotation class colors. ------------------------------------ */

  --ck-color-annotation-wrapper-background: ${theme.semantic.surface.primary};
  --ck-color-annotation-wrapper-drop-shadow: none;

  /* -- Overrides the default .ck-tooltip class colors. --------------------------------------- */

  --ck-color-tooltip-background: ${theme.swatches.blue[900]};
  --ck-color-tooltip-text: ${theme.semantic.foreground.inverse};

  /* -- Overrides the default .ck-table ------------------------------------------------------- */
  --ck-insert-table-dropdown-box-width: ${pxToRem(20)};
  --ck-insert-table-dropdown-box-height: ${pxToRem(20)};

  /* -- Overrides the default .ck-user avatar colors ------------------------------------------ */
  --ck-user-avatar-background: ${theme.semantic.surface.sunken};
  --ck-user-avatar-color: ${theme.swatches.warm[500]};
  --ck-user-avatar-size: ${pxToRem(32)};

  /* -- Overrides the default toolbar dropdown  ----------------------------------------------- */
  --ck-toolbar-dropdown-max-width: ${pxToRem(320)};

  /* -- Overrides the suggestion marker and widget colors */
  --ck-color-suggestion-marker-insertion-border: ${theme.swatches.green[500]};
  --ck-color-suggestion-marker-insertion-border-active: ${theme.swatches.green[300]};
  --ck-color-suggestion-marker-insertion-background: ${theme.swatches.green[50]};
  --ck-color-suggestion-marker-insertion-background-active: ${theme.swatches.green[100]};
  --ck-color-suggestion-box-insertion-border: ${theme.swatches.green[500]};
  --ck-color-suggestion-marker-deletion-border: ${theme.swatches.red[50]};
  --ck-color-suggestion-marker-deletion-border-active: ${theme.swatches.red[300]};
  --ck-color-suggestion-marker-deletion-background: ${theme.swatches.red[50]};
  --ck-color-suggestion-marker-deletion-background-active: ${theme.swatches.red[100]};
  --ck-color-suggestion-box-deletion-border: ${theme.swatches.red[500]};
  --ck-color-suggestion-marker-deletion-stroke: ${theme.swatches.red[500]};
  --ck-color-suggestion-marker-format-border: ${theme.swatches.blue[500]};
  --ck-color-suggestion-marker-format-border-active: ${theme.swatches.blue[300]};
  --ck-color-suggestion-box-format-border: ${theme.swatches.blue[500]};
  --ck-color-comment-marker: color-mix(in srgb, ${theme.swatches.indigo[400]}, transparent 70%);
  --ck-color-comment-marker-active: ${theme.swatches.indigo[200]};
  --ck-color-comment-box-border: ${theme.swatches.indigo[500]};
  --ck-color-base-action: ${theme.swatches.indigo[600]};
  --ck-color-button-save: ${theme.swatches.indigo[500]};
  --ck-z-modal: 1;

  /* -- Overrides the revision history colors  ----------------------------------------------- */
  --ck-revision-history-revision-selected-text-color: ${theme.semantic.foreground.inverse};
  --ck-revision-history-revision-selected-background-color: ${theme.swatches.blue[500]};
  --ck-color-grid-tile-size: ${pxToRem(20)};
`;
